var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertiseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0400391,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F7FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7109 34.2432H25.1328C25.6172 34.2432 26.0273 34.4346 26.3633 34.8174C26.6992 35.2002 26.8672 35.5869 26.8672 35.9775V42.8213C26.8672 43.29 26.6992 43.6924 26.3633 44.0283C26.0273 44.3643 25.6172 44.5322 25.1328 44.5322H21.7109C21.2422 44.5322 20.8398 44.3447 20.5039 43.9697C20.168 43.5947 20 43.2119 20 42.8213V35.9775C20 35.4932 20.168 35.083 20.5039 34.7471C20.8398 34.4111 21.2422 34.2432 21.7109 34.2432ZM30.2891 27.3994H33.7109C34.1797 27.3994 34.582 27.5869 34.918 27.9619C35.2539 28.3369 35.4219 28.7197 35.4219 29.1104V42.8447C35.4219 43.3135 35.2539 43.7158 34.918 44.0518C34.582 44.3877 34.1797 44.5557 33.7109 44.5557H30.2891C29.8203 44.5557 29.418 44.3643 29.082 43.9814C28.7461 43.5986 28.5781 43.2197 28.5781 42.8447V29.1104C28.5781 28.6416 28.7461 28.2393 29.082 27.9033C29.418 27.5674 29.8203 27.3994 30.2891 27.3994ZM38.8672 20.5322H42.2891C42.7578 20.5322 43.1602 20.7236 43.4961 21.1064C43.832 21.4893 44 21.8682 44 22.2432V42.8447C44 43.3135 43.832 43.7158 43.4961 44.0518C43.1602 44.3877 42.7578 44.5557 42.2891 44.5557H38.8672C38.3828 44.5557 37.9727 44.3643 37.6367 43.9814C37.3008 43.5986 37.1328 43.2197 37.1328 42.8447V22.2432C37.1328 21.7744 37.3008 21.3721 37.6367 21.0361C37.9727 20.7002 38.3828 20.5322 38.8672 20.5322Z",
    fill: "#C7C644"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 20 44.04)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertiseIcon);
export default __webpack_public_path__ + "static/media/expertise-icon.42a514a2e2b75c2d3d361d4790c94a57.svg";
export { ForwardRef as ReactComponent };